export { default as SearchPage } from "./searchpage";
